import axios from "@/libs/api.request";
// 获取列表
export const getclaimFee = params => {
  return axios.request({
    url: "/finance/claimBill",
    method: "get",
    params
  });
};

// 获取详情
export const getclaimFeeDetail = params => {
  return axios.request({
    url: "/finance/claimBill/" + params.id,
    method: "get",
    params
  });
};

// 更新
export const updateClaimFee = data => {
  return axios.request({
    url: "/finance/claimBill/" + data.id,
    method: "put",
    data
  });
};

// 更新
export const delClaimFee = id => {
  return axios.request({
    url: "/finance/claimBill/" + id,
    method: "delete"
  });
};

// 确认账单
export const confirmClaimFee = id => {
  return axios.request({
    url: "/finance/claimBill/confirm/" + id,
    method: "post"
  });
};

// 汇率
export const getExchangeRate = data => {
  return axios.request({
    url: "/finance/claimBill/resetAmount/" + data.id,
    method: "post",
    data
  });
};

// 核销
export const writeOff = data => {
  return axios.request({
    url: "/finance/claimBill/writeOff/" + data.id,
    method: "post",
    data
  });
};

// 移出
export const removeClaimFee = data => {
  return axios.request({
    url: "/finance/claimBill/remove/" + data.pid,
    method: "post",
    data
  });
};

// 添加
export const addClaimFee = data => {
  return axios.request({
    url: "/finance/claimBill/add/" + data.id,
    method: "post",
    data
  });
};
